import * as React from 'react';

import { StateContext } from './StateContext';
import { Text, TextContext } from '../TextContext';
import { FormTrigger } from './FormTrigger';
import { $ } from "../../util/$";

// tslint:disable-next-line function-name
export function Status(): JSX.Element | null {
    const text: Text = React.useContext(TextContext);
    const { state, dispatch } = React.useContext(StateContext);
    const [expanded, setExpanded] = React.useState(true);

    const element: HTMLDivElement = $('.js-review') as HTMLDivElement;

    const reviewData: Text = JSON.parse(
        element.getAttribute('data-text') as string,
    );

    if (state.code === undefined) {
        // tslint:disable-next-line no-null-keyword
        return null;
    }

    function handleFocus(event: React.FocusEvent<HTMLInputElement>): void {
        (event.target as HTMLInputElement).select();
    }

    function toggleExpanded(): void {
        setExpanded(!expanded);
    }

    const url: string = `${document.location.origin}/${state.code}`;

    return (
        <aside className="c-quickscan__sidebar">
            <div className="c-quickscan__status">
                <div
                    className={`c-quickscan__status__container  ${
                        expanded ? 'active' : ''
                    }`}
                >
                    <header className="c-quickscan__status__header">
                        <h2 className="c-quickscan__status__title">
                            <button
                                type="button"
                                className="c-quickscan__status__button"
                                onClick={toggleExpanded}
                            >
                                {text.save_title}
                            </button>
                        </h2>
                    </header>
                    <div className="c-quickscan__status__body">
                        <p className="c-quickscan__status__text">
                            {text.save_text}
                        </p>
                        <input
                            onFocus={handleFocus}
                            type="text"
                            className="c-quickscan__status__code"
                            defaultValue={url}
                            placeholder="Shortcode"
                            readOnly={true}
                        />
                        { state.shouldShowButton &&
                            <TextContext.Provider value={reviewData}>
                                <FormTrigger />
                            </TextContext.Provider>
                        }
                    </div>
                </div>
            </div>
            <div></div>
        </aside>
    );
}
